import ViewYard from '@/views/yard/ViewYard.vue'
import ViewStockList from '@/views/yard/ViewStockList.vue'
import ViewAssignStockItems from '@/views/yard/ViewAssignStockItems.vue'
import ViewPickList from '@/views/yard/ViewPickList.vue'
import ViewJourneyList from '@/views/yard/ViewJourneyList.vue'
import ViewAssignPickItems from '@/views/yard/ViewAssignPickItems.vue'
import ViewCollectionList from '@/views/yard/ViewCollectionList.vue'
import ViewAssignCollectionItems from '@/views/yard/ViewAssignCollectionItems.vue'
import ViewAssignJourneyItems from '@/views/yard/ViewAssignJourneyItems.vue'

export default [
	{
		path: '/yard',
		name: 'yard',
		component: ViewYard,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/stock-items',
		name: 'yard-stock-items',
		component: ViewStockList,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/stock-item/:id(.*)',
		name: 'yard-stock-item',
		component: ViewAssignStockItems,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/pick-items',
		name: 'yard-pick-items',
		component: ViewPickList,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/pick-item/:id(.*)',
		name: 'yard-pick-item',
		component: ViewAssignPickItems,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/journey-items',
		name: 'yard-journey-items',
		component: ViewJourneyList,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/journey-item/:id(.*)',
		name: 'yard-journey-item',
		component: ViewAssignJourneyItems,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/collection-items',
		name: 'yard-collection-items',
		component: ViewCollectionList,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	},
	{
		path: '/yard/collection-item/:id(.*)',
		name: 'yard-collection-item',
		component: ViewAssignCollectionItems,
		meta: {
			group: 'yard-workspace',
			permissions: ['view-yard']
		}
	}
]
